import SchemeChoiceRadioButton from "../SchemeChoice/RadioButton/SchemeChoiceRadioButton";
import { sendToControllerIframe } from "../../utils";
import { ELEMENTS, EVENTS, VALIDATION_STATUSES } from "../../constants";

import { resizeElementsForDropdown } from "../shared/toggleFixedSize";

import "../SchemeChoice/RadioButton/SchemeChoiceRadioButtonMultiframe.css";

const MULTI_FRAME_CONTAINING_FIELDS_SELECTORS = [
  "#checkout-frames-card-number",
  ".choices__inner",
];

class SchemeChoiceCardNumberAdapter {
  schemeChoice;
  componentWrapper;

  constructor(env) {
    this.componentWrapper = document.getElementById(
      "checkout-frames-scheme-choice-radio-wrapper"
    );

    this.schemeChoice = new SchemeChoiceRadioButton(env, {
      onValueChange: this.onValueChange,
    });
  }

  onValueChange = (preferredScheme) => {
    sendToControllerIframe(ELEMENTS.SCHEME_CHOICE, {
      event: EVENTS.VALUE_CHANGED,
      value: preferredScheme,
      validationStatus: VALIDATION_STATUSES.VALID,
      previousValidationStatus: VALIDATION_STATUSES.VALID,
    });
  };

  toggleElementVisibility = (value) => {
    this.schemeChoice.toggleElementVisibility(value);
    this.toggleVisibility(value.isDisplayed);
  };

  toggleDropdown = (isDropdownOpen) => {
    resizeElementsForDropdown(
      MULTI_FRAME_CONTAINING_FIELDS_SELECTORS,
      isDropdownOpen
    );
  };

  toggleVisibility = (isDisplayed) => {
    if (isDisplayed) {
      this.componentWrapper.classList.add("active");
      return;
    }

    this.componentWrapper.classList.remove("active");
  };

  getWrapperHeight = () => {
    return this.componentWrapper.getBoundingClientRect().height;
  };
}

export default SchemeChoiceCardNumberAdapter;
